import PropTypes from 'prop-types';

export const SingleContentTopicProps = {
    isActive: PropTypes.oneOf([0, 1, true, false]),
    label: PropTypes.string,
    url: PropTypes.string,
    id: PropTypes.number,
};

export const SingleContentTopicTESTProps = {
    isActive: true,
    label: 'Topic Content In',
    url: '/testUrl',
};

export const FullSingleTopicProps = {
    id: PropTypes.number,
    title: PropTypes.string,
    url: PropTypes.string.isRequired,
    content: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string,
            number: PropTypes.number,
        })
    ),
    total: PropTypes.number,
    sponsored: PropTypes.shape({
        src: PropTypes.string.isRequired,
        alt: PropTypes.string.isRequired,
    }),
    qaDataAttr: PropTypes.string,
};
